import React from 'react';

const NoteContext = React.createContext();

export default NoteContext;